<template lang="pug">
.k-card-text(:class="classes")
  div(:class="{ 'k-card-text__fields': fields }")
    slot
</template>

<script>
import Colorable from 'vuetify/lib/mixins/colorable'
import { Sizeable } from '@/mixins'

export default {
  mixins: [ Colorable, Sizeable ],
  props: {
    fields: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    classes () {
      return {
        ...this.sizeClasses,
        'k-card-text--fields': this.fields,
      }
    }
  }
}
</script>

<style scoped lang="scss">
.k-card-text {
  max-width: 100%;
  padding: 18px;

  @include sm-and-up {
    padding: 26px;
  }

  @include md-and-up {
    padding: 39px;
  }

  &--x-small {
    padding: 7px;
    @include md-and-up {
      padding: 10px;
    }
  }

  &--small {
    padding: 12px;
    @include md-and-up {
      padding: 15px;
    }
  }

  &--semi-medium {
    padding: 21px;
    @include md-and-up {
      padding: 30px;
    }
  }


  //- used in k-card-dashboard, k-kintell-card-full
  &--large {
    padding: 36px 21px;
    @include md-and-up {
      padding: 54px 53px;
    }
  }

  // if fields is set we may need to apply a negative margin to account for the hidden details
  &__fields {
    margin-bottom: -25px;
  }
}
</style>
